export const AUDIO_LRU_MAX = 100;

export function upsertAudiosLru(prev, incoming, pinnedIds, lastUsedRef) {
  const now = Date.now();
  const byId = new Map((prev || []).map((audio) => [String(audio.id), audio]));

  (incoming || []).forEach((audio) => {
    if (!audio) return;
    const id = String(audio.id);
    byId.set(id, { ...byId.get(id), ...audio });
    lastUsedRef.current.set(id, now);
  });

  const pinned = new Set((pinnedIds || []).map(String));
  let entries = [...byId.values()];
  if (entries.length > AUDIO_LRU_MAX) {
    const dropCount = entries.length - AUDIO_LRU_MAX;
    const unpinned = entries
      .filter((audio) => !pinned.has(String(audio.id)))
      .sort((a, b) => (
        (lastUsedRef.current.get(String(a.id)) || 0) - (lastUsedRef.current.get(String(b.id)) || 0)
      ));
    const drop = new Set(unpinned.slice(0, dropCount).map((audio) => String(audio.id)));
    entries = entries.filter((audio) => !drop.has(String(audio.id)));
    drop.forEach((id) => lastUsedRef.current.delete(id));
  }

  return entries;
}
